import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './BooleanPill.css';

const TRUE_VALUES = new Set(['true', 'yes', 'y', '1']);

const isBooleanTrue = (value) => {
  if (value === true) return true;
  if (value === false || value == null) return false;
  return TRUE_VALUES.has(String(value).trim().toLowerCase());
};

const BooleanPill = ({ value, trueLabel = 'Yes', falseLabel = 'No', className = '' }) => {
  const isTrue = isBooleanTrue(value);
  return (
    <span className={`boolean-pill ${isTrue ? 'yes' : 'no'} ${className}`.trim()}>
      {isTrue ? trueLabel : falseLabel}
    </span>
  );
};

const BooleanSelectEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(isBooleanTrue(props.value) ? 'Yes' : 'No');
  const selectRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getValue: () => value === 'Yes',
    afterGuiAttached: () => {
      selectRef.current?.focus();
    },
  }));

  useEffect(() => {
    selectRef.current?.focus();
  }, []);

  return (
    <select
      ref={selectRef}
      className="boolean-select-editor"
      value={value}
      onChange={(event) => {
        setValue(event.target.value);
        props.onValueChange?.(event.target.value === 'Yes');
      }}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <option value="No">No</option>
      <option value="Yes">Yes</option>
    </select>
  );
});

BooleanSelectEditor.displayName = 'BooleanSelectEditor';

export { BooleanSelectEditor, isBooleanTrue };
export default BooleanPill;
